import PropTypes from 'prop-types';

const SentMessagePropType = {
  isScheduled: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  onNewMessageClick: PropTypes.func.isRequired,
};

export default SentMessagePropType;
